import * as React from "react";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { Avatar, Paper } from "@mui/material";
import { NavLink } from "react-router-dom";
import { Box } from "@mui/joy";
import { Badge } from "@mui/material";



export default function BottomNav() {
  let userCart = localStorage.getItem("cart");
  userCart = userCart ? JSON.parse(userCart) : [];
  return (
    <Box className="mobile-tabs" >
      <Paper sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 999999 }}>
        <BottomNavigation showLabels>
          <BottomNavigationAction
            label="Home"
            value="Home"
            component={NavLink}
            to="/"
            icon={
              <Avatar
                sx={{ width: "30px", height: "30px" }}
                alt="Home"
                src={process.env.PUBLIC_URL + "/assets/images/home-icon.gif"}
              />
            }
          />

          <BottomNavigationAction
            label="Search"
            value="search"
            component={NavLink}
            to="/search"
            icon={
              <Avatar
                sx={{ width: "30px", height: "30px" }}
                alt="search"
                src={process.env.PUBLIC_URL + "/assets/images/search-box.gif"}
              />
            }
          />

          {/* <BottomNavigationAction
            label="Orders"
            value="orders"
            component={NavLink}
            to="/orderlist"
            icon={
              <Avatar
                sx={{ width: "30px", height: "30px" }}
                alt="orders"
                src={process.env.PUBLIC_URL + "/assets/images/order-food.gif"}
              />
            }
          /> */}



          <BottomNavigationAction
            label="Cart"
            value="cart"
            component={NavLink}
            to="/cart"
            icon={
              <Badge badgeContent={userCart.length} color="error">
                <Avatar
                  sx={{ width: "30px", height: "30px" }}
                  alt="Cart"
                  src={process.env.PUBLIC_URL + "/assets/images/cart-icon.gif"}
                />
              </Badge>
            }
          />


          <BottomNavigationAction
            label="More"
            value="account"
            component={NavLink}
            to="/account"
            icon={
              <Avatar
                sx={{ width: "30px", height: "30px" }}
                alt="Home"
                src={process.env.PUBLIC_URL + "/assets/images/user-icon.gif"}
              />
            }
          />
        </BottomNavigation>
      </Paper>
    </Box>
  );
}
